import PropTypes from "prop-types";

export default PropTypes.shape({
  id: PropTypes.number,
  onDemand: PropTypes.bool,
  shortName: PropTypes.string,
  clientName: PropTypes.string,
  branding: PropTypes.shape({
    portalPrimaryColor: PropTypes.string,
    portalSecondaryColor: PropTypes.string,
    statsLogo: PropTypes.string,
    portalLogo: PropTypes.string,
    relationshipLogo: PropTypes.string
  }),
  children: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number,
      logo: PropTypes.string
    })
  ),
  features: PropTypes.shape({
    ondemand: PropTypes.bool,
    help: PropTypes.bool,
    social: PropTypes.bool,
    network: PropTypes.bool,
    ppv: PropTypes.bool,
    useVideoJS: PropTypes.bool,
    ads: PropTypes.shape({
      legacyPreroll: PropTypes.bool,
      usePreRoll: PropTypes.bool,
      googleBanner: PropTypes.bool,
      googlePlayer: PropTypes.bool
    })
  })
});
